import SectionHeading from '@/components/base/SectionHeading';
import { services } from '@/mocks/home';

export default function Services() {
  return (
    <section id="services" className="py-16 md:py-20 lg:py-[112px] px-4 md:px-6 lg:px-20">
      <div className="max-w-content mx-auto">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6">
          <SectionHeading eyebrow="WHAT WE DO" title="A Little More Clean. A Lot More Comfort." sub="From everyday upkeep to a fresh start, find the right cleaning service for your home." />
          <a href="#quote" className="rv-link text-sm font-medium text-secondary-500 hover:text-secondary-700 whitespace-nowrap cursor-pointer inline-flex items-center gap-1">Request a quote <i className="ri-arrow-right-up-line" /></a>
        </div>
        <div data-reveal-group className="mt-12 md:mt-16 grid grid-cols-1 md:grid-cols-3 gap-5 lg:gap-6">
          {services.map((s) => (
            <a key={s.title} href="#quote" className="group cursor-pointer hover-lift">
              <div data-reveal="image" className="w-full h-[360px] md:h-[340px] lg:h-[460px] rounded-[20px] overflow-hidden bg-background-100">
                <img loading="lazy" decoding="async" src={s.image} alt={`${s.title} by CLEARY`} title={`${s.title} — CLEARY home cleaning`} className="w-full h-full object-cover object-top hover-zoom-img" />
              </div>
              <div className="pt-6 flex items-start justify-between gap-4">
                <div>
                  <h3 className="font-heading text-[22px] lg:text-[26px] leading-[1.25] font-medium">{s.title}</h3>
                  <p className="mt-2 text-[15px] md:text-base leading-[1.6] text-foreground-600">{s.text}</p>
                </div>
                <span className="shrink-0 w-11 h-11 rounded-full border border-background-300 flex items-center justify-center text-secondary-500 transition-colors group-hover:bg-background-200"><i className="ri-arrow-right-up-line text-lg" /></span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}